import { Box, Skeleton, Typography } from '@customink/pigment-react';
import {
  BULK_SPLIT_SHIP,
  usePricing,
  useProject,
} from '@customink/project-service-react-components';
import Big from 'big.js';

export function DeliveryMultiShipLineItem() {
  const { data: project } = useProject();
  const { isFetching } = usePricing();

  const addressCount = project?.distributedOrder?.numberOfAddresses || 2;

  const deliveryCost = Big(BULK_SPLIT_SHIP.SHIPPING_FEE)
    .times(addressCount)
    .toFixed(2);

  return (
    <>
      <Box
        data-testid="delivery-multi-ship-line-item"
        display="flex"
        justifyContent="space-between"
      >
        <Typography
          component="div"
          data-testid="multi-ship-address-count"
          variant="uiTextDefault"
        >
          Est. Delivery
          <Typography variant="uiTextSmall">
            {' '}
            ({addressCount}&nbsp;addresses)
          </Typography>
        </Typography>
        <Typography
          className={isFetching ? 'pje-fetching-text' : ''}
          data-testid="multi-ship-price"
          variant="uiTextDefault"
        >
          {isFetching ? (
            <Skeleton sx={{ display: 'inline-block' }} width={25} />
          ) : (
            <>${deliveryCost}</>
          )}
        </Typography>
      </Box>
    </>
  );
}
